import { BasicMatch, DetailedMatch } from "@/data/match";
import { useGetMatch } from "@/hooks/frontend/match";
import { Season } from "@/models/Season";
import { News } from "@/models/types";
import { useRouter } from "next/router";
import { Gameday } from "../../models/Gameday";
import { MatchWithTeamsAndVenueAndGamedayAndSeason } from "../../models/Match";
import { GamedayHeader } from "../GamedayHeader";
import { NoItems } from "../common/NoItems";
import { GamedayMatchDetail } from "./GamedayMatchDetail";
import { GamedayMatchList } from "./GamedayMatchList";

interface GamedayViewProps {
  selectedGameday: Gameday;
  gamedays: Gameday[];
  matches: BasicMatch[];
  selectedMatch: DetailedMatch;
  baseUrl: string;
  news?: News | null;
  season: Season;
  comparisonMatches: MatchWithTeamsAndVenueAndGamedayAndSeason[];
}

export function GamedayView({
  gamedays,
  matches,
  selectedMatch,
  selectedGameday,
  baseUrl,
  news,
  season,
  comparisonMatches,
}: GamedayViewProps) {
  const { push } = useRouter();
  const { data } = useGetMatch({ id: selectedMatch.id });
  return (
    // <ErrorBoundary fallback={<div>Fehler beim Laden des Matches</div>}>
    <>
      <div className="lg:hidden flex justify-center py-4">
        <GamedayHeader
          gamedays={gamedays}
          setCurrentGameday={(g) => push(`${baseUrl}/${g.index}/current`)}
          intitialGamedayIndex={selectedGameday.index}
        />
      </div>
      {matches.length === 0 ? (
        <div className="container">
          <NoItems />
        </div>
      ) : (
        <>
          {selectedMatch && (
            <>
              <GamedayMatchList
                matches={matches}
                selectedMatchIndex={matches.findIndex(
                  (m) => m.id === selectedMatch.id
                )}
                baseUrl={`${baseUrl}/${selectedGameday.index}`}
                season={season}
              />
              <GamedayMatchDetail
                match={data ?? selectedMatch}
                news={news}
                season={season}
                comparisonMatches={comparisonMatches}
              />
            </>
          )}
        </>
      )}
    </>
    // </ErrorBoundary>
  );
}
